import { useState, useEffect } from "react";
import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { PortfolioGrid, CTA } from "../components/Sections";
import { PROJECTS, PORTFOLIO_FILTERS } from "../data";
import api from "../lib/api";

const norm = (str) => (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");

export default function Portfolio() {
  const [filter, setFilter] = useState("All");
  const [projectList, setProjectList] = useState(PROJECTS);

  useEffect(() => {
    api.get("/projects")
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setProjectList(() => {
            const merged = [...PROJECTS];
            res.data.forEach((p) => {
              const idx = merged.findIndex((m) => m.slug === p.slug);
              if (idx >= 0) merged[idx] = { ...merged[idx], ...p };
              else merged.push(p);
            });
            return merged;
          });
        }
      })
      .catch(() => {});
  }, []);

  const items = filter === "All"
    ? projectList
    : projectList.filter((p) => {
        const pSector = norm(p.sector || p.industry || "");
        const target = norm(filter);
        if (target === "b2bindustry") {
          return pSector === "b2bindustry" || pSector === "b2b";
        }
        if (target === "artsculture") {
          return pSector === "artsculture" || pSector.includes("art");
        }
        return pSector === target;
      });

  return (
    <Layout>
      <Seo title="Portfolio - Our Work & Case Studies" description="Explore Neuravolt's portfolio of industry solutions, client impact, and digital transformation projects across healthcare, retail, manufacturing, logistics, and more." keywords="Neuravolt portfolio, industry case studies, software development projects, digital transformation work India" path="/portfolio" />
      <PageHero eyebrow="Portfolio" title="Work we're proud of" sub="Real products and solutions we've designed, built and scaled across industries." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 -mb-10">
        <div className="flex flex-wrap gap-2">
          {PORTFOLIO_FILTERS.map((f) => (
            <button key={f} data-testid={`filter-${f.toLowerCase().replace(/[\s&]+/g, "-")}`} onClick={() => setFilter(f)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors ${filter === f ? "bg-[#FF5A1F] text-white" : "bg-white border border-black/5 text-neutral-600 hover:text-[#FF5A1F]"}`}>
              {f}
            </button>
          ))}
        </div>
      </div>
      {items.length ? <PortfolioGrid items={items} heading={false} />
        : <div className="max-w-7xl mx-auto px-5 sm:px-8 py-28 text-center text-neutral-400">No projects in this industry yet. Coming soon.</div>}

      <CTA />
    </Layout>
  );
}
